module.exports = __webpack_public_path__ + "static/media/dollar.0abcd7ee.svg";